import React, { useRef } from 'react'
import { Link } from "react-router-dom";
import { AiOutlineCloudDownload } from 'react-icons/ai'

function Button() {
   const button = useRef();
   return (
    <div ref={button} className='hidden md:block fixed bottom-[20px] right-[20px] text-7xl text-blue bg-white hover:bg-blue hover:text-white transition-colors ease-in-out delay-150 rounded-full p-1'>
       <Link to="/download">
       <AiOutlineCloudDownload/>
       </Link>
       
    </div>
  )
}

export default Button